import React from 'react';

const Mountain = ({ fill = '#000000' }) => (
  <svg
    stroke="currentColor"
    fill="none"
    strokeWidth="2"
    viewBox="0 0 24 28"
    strokeLinecap="round"
    strokeLinejoin="round"
    height="20px"
    width="18px"
  >
    <path d="m8 3 4 8 5-5 5 15H2L8 3z"></path>
  </svg>
);

export default Mountain;
